<template>
  <validation-observer
    ref="createExamCountQuestionFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="createExamCountQuestionModal"
      body-class="position-static"
      centered
      title="Tạo đề thi với số lượng câu hỏi"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group
              label-for="subjectId"
            >
              <template v-slot:label>
                Học phần <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Học phần"
                rules="required"
              >
                <v-select
                  v-model="targetDataSource.subjectId"
                  placeholder="Học phần"
                  :options="subjects"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-for="countQuestion">
              <template v-slot:label>
                Số lượng câu hỏi  <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Số lượng câu hỏi"
                rules="required"
              >
                <b-form-input
                  id="countQuestion"
                  v-model="targetDataSource.countQuestion"
                  name="countQuestion"
                  placeholder="Số lượng câu hỏi"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-for="countExam">
              <template v-slot:label>
                Số lượng đề thi  <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Số lượng đề thi"
                rules="required"
              >
                <b-form-input
                  id="countExam"
                  v-model="targetDataSource.countExam"
                  name="countExam"
                  placeholder="Số lượng đề thi"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Tạo đề
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('createExamCountQuestionModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
        no-wrap
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BModal, BOverlay, BButton, BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { QB_EXAM_STATUSES } from '@/const/status'
import Cleave from 'vue-cleave-component'
import { getUser } from '@/auth/utils'

export default {
  name: 'Save',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Cleave,
    vSelect,
    BCol,
    BRow,
    BFormInput,
    ValidationProvider,
    BFormGroup,
    BModal,
    BForm,
    BOverlay,
    BButton,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    dataForm: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      targetDataSource: {
        subjectId: null,
        countExam: 0,
        countQuestion: 0,
      },
      filter: {
        currentPage: 1,
        itemsPerPage: 1000,
        status: 1,
      },
      required,
      subjectIdTemp: null,
    }
  },
  computed: {
    ...mapGetters({
      subjects: 'qbQuestion/subjects',
    }),
    isCreated() {
      return !this.dataForm
    },
    statuses() {
      return QB_EXAM_STATUSES
    },
  },
  methods: {
    ...mapActions({
      createExamByCountQuestion: 'qbExams/createExamByCountQuestion',
      getSubjects: 'qbQuestion/getSubjects',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      await this.getSubjects({ organizationId: getUser().orgId })
      if (this.dataForm) {
        this.targetDataSource = { ...this.dataForm }
      }
    },
    onHide() {
      this.$refs
        .createExamCountQuestionFormRef
        .reset()
      this.targetDataSource = {
        id: null,
        code: '',
        name: '',
        status: 1,
        orderNo: 1,
        subjectId: null,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .createExamCountQuestionFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        this.subjectIdTemp = this.targetDataSource.subjectId
        try {
          const response = await this.createExamByCountQuestion(this.targetDataSource)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              this.$emit('succeed', this.subjectIdTemp)
              if (type === 'hide') {
                this.$bvModal.hide('createExamCountQuestionModal')
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>
